import { createAsyncThunk } from "@reduxjs/toolkit";

import { ErrorWithCode } from "Api/types/ErrorWithCode";
import logger from "Libs/logger";
import client from "Libs/platform";
import { AsyncThunkOptionType } from "Reducers/types";

import type { GetOrganizationOrderPropType } from "../types";
import type { OrganizationOrder } from "@packages/client";

export const getOrganizationOrderThunk = createAsyncThunk<
  OrganizationOrder | undefined,
  GetOrganizationOrderPropType,
  AsyncThunkOptionType<{ error: ErrorWithCode }>
>(
  "organization/order",
  async ({ organizationId, orderId, includeDetails }, { rejectWithValue }) => {
    try {
      const order = await client.getOrganizationOrder(
        organizationId,
        orderId,
        includeDetails
      );

      return order;
    } catch (_error: unknown) {
      const error = _error as ErrorWithCode;
      if (![404, 403].includes(error.code)) {
        logger(error, {
          action: "organization_load_orders",
          orderId
        });
      }

      return rejectWithValue({ error });
    }
  }
);
